import { z } from "zod";
export const Url = z.union([z.string().startsWith("https://"), z.string().startsWith("http://")]) as z.Schema<
  `https://${string}` | `http://${string}`
>;
